import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { LayoutComponentContext } from "../ComponentContext/LayoutComponentContext";
import { EmptyColumnHandlingProvider } from "./EmptyColumnHandlingProvider";
import { LayoutRowContext } from "./LayoutRowContext";
import { LayoutRowDebug } from "./LayoutRowDebug";
/**
 * Layout row in react-page layout
 * @param props
 * @returns
 */
export function LayoutRow(props) {
    const { node } = props;
    const LayoutGrid = useContext(LayoutComponentContext).LayoutGrid;
    return (_jsx(LayoutRowContext.Provider, { value: node, children: _jsx(EmptyColumnHandlingProvider, { emptyColumnHandling: node.emptyColumnHandling, children: _jsx(LayoutRowDebug, { row: node, children: _jsx(LayoutGrid, { node: props.node, gridContainer: props.gridContainer, gridType: props.gridType }) }) }) }));
}
//# sourceMappingURL=LayoutRow.js.map